<template>
  <div class="pending-apps-section">
    <div class="back-arrow" v-on:click="back" v-if="isSelected" tabindex="0" @keydown.enter.space.stop="back" style="outline: none; cursor: pointer;">
      <svg-icon :name="'back-arrow'"></svg-icon>
      <span>Back</span>
    </div>
    <div class="section-title" v-if="isShowApplicationTitle">{{ currentSelectedApplication.application.programType }}</div>
    <div class="section-title" v-if="!isSelected">
      <div class="my-applications">
        <div style="padding: 10px 0;">My Applications</div>
        <div class="bth-group">
          <maf-button :name="'Go to financial education'" :width="290" :bgColor="'-webkit-linear-gradient(left top, rgb(255, 121, 14), rgb(255, 88, 88))'" @actionFunc="goToFinancialEducation"/>
          <maf-button :name="'Start a new application'" :width="290" :bgColor="'-webkit-linear-gradient(left top, rgb(48, 35, 174), rgb(200, 109, 215))'" @actionFunc="startApplication"/>
        </div>
      </div>
    </div>
    <div v-if="isSelected">
      <div v-for="(page, index) in currentSelectedApplication.pages" :key="index">
        <div class="pending-list">
          <div class="pending-item page">
            <svg-icon v-if="page.name === 'Program Application'" :name="'program-app'"></svg-icon>
            <svg-icon v-if="page.name === 'Financial Education'" :name="'financial-education'"></svg-icon>
            <svg-icon v-if="page.name === 'Survey'" :name="'survey'"></svg-icon>
            <span>{{index + 1 + '. ' + page.name }}</span>
          </div>
          <div class="pending-item" :class="[!isShowCompletedSection(page) ? 'app-status-div-completed' : '', 'app-status-div']">
            <svg-icon :name="pageStatus(page, 'svg')"></svg-icon>
            <span> {{ pageStatus(page, 'text') }} </span>
          </div>
          <div class="pending-item start-btn" v-show="isShowCompletedSection(page)">
            <maf-button v-show="page.status === 'UnStarted'" :name="'Start'" :width="234" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="openPage(page.pageUrl, page.name === 'Financial Education' ? '_blank' : '_self')"/>
            <maf-button v-show="isShowCompletedSectionBtn(page, 'Continue')" :name="'Continue'" :width="234" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="openPage(page.pageUrl, '_self')"/>
            <div style="color: #878787;" v-show="isShowCompletedSectionBtn(page, 'Submitted')">Submitted on {{ getSubmittedTime(currentSelectedApplication.application.submittedTime) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in pendingApplications" :key="index">
      <div class="pending-list" v-if="!isSelected">
        <div class="pending-item app-name-div">
          <svg-icon v-if="item.application.programType !== 'LLC Loan'" :name="'pending-immigration-app'"></svg-icon>
          <svg-icon v-if="item.application.programType === 'LLC Loan'" :name="'pending-llc-app'"></svg-icon>
          <span>{{ item.application.programType }}</span>
        </div>
        <div class="pending-item app-status-div">
            <svg-icon v-if="getApplicationStatus(item) === 'Incomplete'" :name="'incomplete'"></svg-icon>
            <svg-icon v-if="getApplicationStatus(item) === 'Under Review'" :name="'under-review'"></svg-icon>
            <svg-icon v-if="getApplicationStatus(item) === 'Approved'" :name="'completed'"></svg-icon>
            <svg-icon v-if="getApplicationStatus(item) === 'Withdrawn' || getApplicationStatus(item) === 'Ineligible'" :name="'withdrawn'"></svg-icon>
            <span>{{ getApplicationStatus(item) }}</span>
        </div>
        <div class="pending-item app-btn-div">
          <maf-button v-if="isShowVewDetails(item)" :name="'View details'" :min-width="220" @actionFunc="viewDetails(item.application)"/>
          <maf-button v-if="isShowContinue(item)" :name="'Continue application'" :min-width="220" @actionFunc="continueApplication(item)"/>
          <span v-if="isShowSubmittedTime(item)"> Sent on {{ getSubmittedTime(item.application.submittedTime) }}</span>
          <span v-if="getApplicationStatus(item) === 'Ineligible' || (item.application.source !== null && item.application.source.startsWith('IFRP') && item.application.source !== 'IFRP-Loan' && getApplicationStatus(item) === 'Withdrawn')"> Submitted</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getViewLoansRemoting } from '../../api';

export default {
  name: 'PendingApps',
  props: {},
  data () {
    return {
      isSelected: false,
      currentSelectedApplication: {}
    };
  },
  watch: {
  },
  computed: {
    ...mapState({
      pendingApplications: state => state.dashboardHomeData.pendingApps,
      isLoading: state => state.isLoading,
      currentTab: state => state.currentTab,
      isMobile: state => state.isMobile,
      userInfo: state => state.userInfo,
      contactInfo: state => state.contactInfo,
      retAdobeLMSUrl: state => state.retAdobeLMSUrl
    }),

    isHome() {
      return this.currentTab.label === 'Home';
    },

    isUnLocked() {
      if (!this.currentSelectedApplication.application.isLock && (this.currentSelectedApplication.application.applicationStatus === 'Pending' || this.currentSelectedApplication.application.applicationStatus === 'Pending Client Edits')) {
        return true;
      }

      return false;
    },

    isShowApplicationTitle () {
      return this.isSelected && this.currentSelectedApplication.application && this.currentSelectedApplication.application.name;
    },

  },
  mounted() {
    this.setRecordById();
  },
  methods: {
    setRecordById() {
      const id = this.$route.params.recordId;
      if (id) {
        let viewRecord = this.pendingApplications.filter((item) => (item.application.id).substring(0, 15) === id.substring(0, 15));
        if (viewRecord) {
          this.viewDetails(viewRecord[0].application);
        } else {
          console.error('No matching record found by Id');
        }
      }
    },
    isFinEDCompleted(pendingApplication) {
      let isCompleted = true;
      pendingApplication.pages.forEach((page) => {
        if (page.name === 'Financial Education' && page.status === 'UnStarted') {
          isCompleted = false;
        }
      });

      return isCompleted;
    },

    isSurveyCompleted(pendingApplication) {
      let isCompleted = false;
      pendingApplication.pages.forEach((page) => {
        if (page.name === 'Survey' && page.status === 'Completed') {
          isCompleted = true;
        }
      });

      return isCompleted;
    },

    getApplicationStatus(pendingApplication) {
      if (this.isGrantApplication(pendingApplication) || this.isMIJAGrant(pendingApplication)) {
        if (pendingApplication.application.applicationStatus === 'Pending'
          || pendingApplication.application.applicationStatus === 'Pending Client Edits'
          || (this.isMIJAGrant(pendingApplication) && !this.isSurveyCompleted(pendingApplication) && pendingApplication.application.applicationStatus !== 'Deleted')) {
          return 'Incomplete';
        } else if (pendingApplication.application.applicationStatus === 'Submitted' || pendingApplication.application.applicationStatus === 'Pending Client Response' || pendingApplication.application.applicationStatus === 'Pending Approval') {
          return 'Under Review';
        } else if (pendingApplication.application.applicationStatus === 'Approved' || pendingApplication.application.applicationStatus === 'Grant Approved' || pendingApplication.application.applicationStatus === 'Scholarship Approved') {
          return 'Approved';
        } else if (pendingApplication.application.applicationStatus === 'Deleted') {
          return 'Withdrawn';
        } else if (pendingApplication.application.applicationStatus === 'Ineligible') {
          return 'Ineligible';
        } else if ((pendingApplication.application.applicationStatus === 'Started Grant Program' || pendingApplication.application.applicationStatus === 'Completed Grant Program') && pendingApplication.application.source !== null && pendingApplication.application.source.startsWith('IFRP')) {
          return 'Approved';
        }
      }

      let isCompleted = this.isNotFinEdRequired(pendingApplication) ? true : this.isFinEDCompleted(pendingApplication);
      if (pendingApplication.application.applicationStatus === 'Pending'
        || pendingApplication.application.applicationStatus === 'Pending Client Edits'
        || ((pendingApplication.application.applicationStatus === 'Submitted' || pendingApplication.application.applicationStatus === 'Approved' || pendingApplication.application.applicationStatus === 'Pending Approval') && !isCompleted)) {
        return 'Incomplete';
      }

      if (isCompleted && (pendingApplication.application.applicationStatus === 'Submitted' || pendingApplication.application.applicationStatus === 'Approved' || pendingApplication.application.applicationStatus === 'Pending Approval')) {
        return 'Under Review';
      }

      if (pendingApplication.application.applicationStatus === 'Ready to Join LC' || pendingApplication.application.applicationStatus === 'Joined' || pendingApplication.application.applicationStatus === 'Grant Approved') {
        return 'Approved';
      }

      if (pendingApplication.application.applicationStatus === 'Deleted') {
        return 'Withdrawn';
      }
    },

    isShowCompletedSection(page) {
      if (this.isMobile === true && page.status === 'Completed') {
        if (page.name === 'Financial Education' || page.name === 'Survey') {
          return false;
        } else if (!this.isUnLocked) {
          return false;
        }
      }

      return true;
    },

    isShowCompletedSectionBtn(page, type) {
      if (type === 'Continue') {
        return page.name !== 'Financial Education' && page.name !== 'Survey' && page.status === 'Incomplete' && this.isUnLocked;
      }

      if (type === 'Submitted') {
        return page.name !== 'Financial Education' && page.name !== 'Survey' && page.status === 'Completed';
      }
    },

    isGrantApplication(currentPendingApp) {
      if (currentPendingApp.pages.length === 0 || currentPendingApp.application.source === 'DACA Loan') {
        return true;
      }

      return false;
    },

    pageStatus(page, type) {
      if (page.status === 'Completed') {
        if (type === 'svg') {
          return 'completed';
        }
        return 'Completed';
      } else {
        if (type === 'svg') {
          return 'incomplete';
        }
        return 'Incomplete';
      }
    },

    isShowVewDetails(item) {
      if (this.isNotFinEdRequired(item) && this.getApplicationStatus(item) === 'Under Review' && !this.isFinEDCompleted(item)) {
        return true;
      }

      if (!this.isGrantApplication(item) && this.getApplicationStatus(item) === 'Incomplete') {
        return true;
      }

      return false;
    },

    isNotFinEdRequired(item) {
      return !item.application.finEdRequired;
    },

    isMIJAGrant(item) {
      if (item.application.source) {
        return item.application.source === 'Immigration-Grant-OCEIA' || item.application.source === 'Flex-Immigration-Grant' || item.application.source.startsWith('MIJA-Grant');
      }
      return false;
    },

    viewDetails(item) {
      this.isSelected = true;
      this.pendingApplications.forEach((pendingApplication) => {
        if (pendingApplication.application.id.substring(0, 15) === item.id.substring(0, 15)) {
          this.currentSelectedApplication = pendingApplication;
          this.$router.push(`/pendingApps/${this.currentSelectedApplication.application.id}`);
        }
      });

      this.$nextTick(() => {
        document.getElementById('mainPage').scrollIntoView();
      })
    },

    isShowContinue(item) {
      if (this.getApplicationStatus(item) === 'Incomplete' && this.isGrantApplication(item)) {
        return true;
      }
      return false;
    },

    continueApplication(item) {
      let url;
      if (item.application.source === 'DACAPreAppGrant' || item.application.source === 'DACA-OCEIA') {
        url = 'SADACA21Application';
      } else if (item.application.source === 'DACALoan' || item.application.source === 'DACA-Loan-OCEIA') {
        url = 'NCALoanApplication';
      } else if (item.application.source !== null && item.application.source.startsWith('IFRP') && (item.application.applicationStatus === 'Pending' || item.pendingApplication.application.applicationStatus === 'Pending Client Edits')) {
        if (item.application.pageStatus === 'UnStarted') {
          url = 'IFRPApplicationOne';
        }
        if (item.application.pageStatus === 'Started') {
          url = 'IFRPApplicationTwo';
        }
        if (item.application.pageStatus === 'Incomplete') {
          if (!item.application.isAuthenticateCognito) {
            url = 'AuthenticateApplicant';
          } else {
            url = 'IFRPApplicationThree';
          }
        }
      }

      url += '?id=' + item.application.id;
      this.openPage(url, '_self');
    },

    isShowSubmittedTime(item) {
      if (!item.application.submittedTime) {
        return false
      }

      if (this.getApplicationStatus(item) === 'Approved') {
        return true;
      }

      if (this.isNotFinEdRequired(item)) {
        if (this.getApplicationStatus(item) === 'Under Review' && this.isFinEDCompleted(item)) {
          return true;
        }
        return false;
      }
      if (this.getApplicationStatus(item) === 'Under Review' || (this.getApplicationStatus(item) === 'Withdrawn' && item.application.source !== null && !item.application.source.startsWith('IFRP'))) {
        return true;
      }

      return false;
    },

    getSubmittedTime(str) {
      if (str !== null) {
        var newDate = new Date(str);
        return newDate.toLocaleDateString();
      }
    },

    back() {
      this.isSelected = false;
      this.$router.push('/pendingApps');
    },

    async openPage(url, target) {
      if (target === '_blank') {
      } else {
        await getViewLoansRemoting(this.userInfo.userId);
      }

      if (url && url.indexOf('https') !== -1) {
      } else {
        url = '/lendingcircles/' + url;
      }
      window.open(url, target);
    },

    async startApplication() {
      const loanErrorPopup = await getViewLoansRemoting(this.userInfo.userId);
      console.log(loanErrorPopup)
      if (loanErrorPopup.isShow) {
        this.$store.commit('SHOW_LOANS_POPUP', loanErrorPopup);
      } else {
        this.$store.commit('IS_POPUP_STEP_CHANGED', 2);
      }
      this.$store.commit('IS_CUSTOM_POPUP_CHANGED', true);
      this.$trackEvent('Start application clicked', this.userInfo);
    },

    goToFinancialEducation() {
      if (this.retAdobeLMSUrl && this.retAdobeLMSUrl.indexOf('https') !== -1) {
        window.open(this.retAdobeLMSUrl, '_blank');
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import './../../sass/main.scss';

$mobile-left-distance: 15px;
$mobile-submit-btn-width: 284px;
$border-width: 2px;
$border-color: #fff;

.pending-apps-section {
  @include inner-component-pc;

  @media screen and (max-width: $max-width-phone) {
    @include inner-component-mobile;
    width: unset;
    font-size: $font-size-base;

    .maf-btn {
      width: 100% !important;
    }
  }

  .section-title {
    @include section-title;

    @media screen and (max-width: $max-width-phone) {
      font-size: $font-size-larger;
    }
  }

  .section-sub-title {
    @include section-sub-title;
    font-size: $font-size-larger;

    @media screen and (max-width: $max-width-phone) {
      font-size: $font-size-large;
    }
  }

  .pending-section-home-title {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: $max-width-phone) {
      display: block;
    }
  }

  .start-application {
    font-family: sans-serif;
    font-size: 18px;
    color: #878787;
    cursor: pointer;

    @media screen and (max-width: $max-width-phone) {
      margin-top: 10px;
    }
  }

  .submit-btn {
    margin-right: 33px;
    float:right;

    @media screen and (max-width: $max-width-phone) {
      margin: 15px;
      @include flex-row;
      justify-content: center;
      float: none;
      width: unset;
    }
  }

  .back-arrow {
    margin-bottom: 20px;
    @include space-between-style;
    width: 70px;
    color: $font-color-sub-title;
    cursor: pointer;
  }

  .my-applications {
      display: flex;
      justify-content: space-between;

      @media screen and (max-width: $max-width-phone) {
        flex-direction: column;
    }
  }

  .pending-list {
    margin-bottom: 10px;
    @include space-around-style;
    background: #F4F4F4;
    font-size: 18px;
    color: $font-color-sub-title;
    border-radius: 7px;

    @media screen and (max-width: $max-width-phone) {
      flex-direction: column;
      align-items: start;
      font-size: $font-size-base;
    }

    .app-status-div-completed {
      border-bottom-right-radius: 7px;
      border-bottom-left-radius: 7px;
    }

    .pending-item {
      padding: 15px;
      @include center-style;
      min-height: 72px;
      background: #F4F4F4;

      @media screen and (max-width: $max-width-phone) {
        .maf-btn {
          width: 100% !important;
        }
      }
    }

    span {
      margin-left: 10px;
      flex: 1;
    }

    .page {
      flex: 1;
      border-radius: 7px;
    }

    .start-btn {
      justify-content: center;
      border-radius: 7px;
      width: 302px;

      @media screen and (max-width: $max-width-phone) {
        width: 100%;
        .maf-btn {
          width: 100% !important;
        }
      }
    }

    .app-name-div {
      flex: 1;
      border-radius: 7px;

      @media screen and (max-width: $max-width-phone) {
        width: unset;
      }
    }

    .app-status-div {
      border-right: $border-width solid $border-color;
      border-left: $border-width solid $border-color;
      width: 205px;

      @media screen and (max-width: $max-width-phone) {
        width: 100%;
        border-right: unset;
        border-left: unset;
        border-bottom: $border-width solid $border-color;
        border-top: $border-width solid $border-color;
      }
    }

    .app-btn-div {
      justify-content: center;
      border-radius: 7px;
      width: 260px;

      @media screen and (max-width: $max-width-phone) {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pending-apps/PendingApps.vue